import React, { useEffect, useState, useRef } from 'react';
import CCPContainer from '../CCPContainer';
import InfoTab from '../InfoTab';
import NotLoggedIn from '../NotLoggedIn';
import 'amazon-connect-streams';
import 'amazon-connect-chatjs';
import 'aws-sdk/clients/connectparticipant'; // <-- IMPORTANT - should be last
import config from '../../../utils/env-config/env-config.json';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import remoteConfigManager from '../../../utils/remote-config-manager';
import { identify, event } from 'react-fullstory';
import './ParentContainer.css';
import webApisClient from '../../../utils/web-apis-client';

const ParentContainer = () => {
  const [user, setUser] = useState(remoteConfigManager.getUser());
  const [loggedIn, setLoggedIn] = useState(true);
  const [contacts, _setContacts] = useState([]);
  const [showInfoPanel, setShowInfoPanel] = useState(false);
  const [attributesMap, setAttributesMap] = useState({});
  const [showSpinner, setShowSpinner] = useState({});
  const [ccpWidth, setCCPWidth] = useState(95);
  const [ccpInitialized, setccpInitialized] = useState(false);
  const [surveyCalls, setSurveyCalls] = useState([]);
  const [surveyChats, setSurveyChats] = useState([]);
  const [surveyCallbackTask, setSurveyCallbackTask] = useState([]);
  const [surveyFailureTask, setSurveyFailureTask] = useState([]);
  const [surveyIntermittentAbsenceTask, setSurvveyIntermittentAbsenceTask] = useState([]);
  const [surveyRequestTypeOptions, setSurveyRequestTypeOptions] = useState([]);
  const [surveyWorkItemTypeOptions, setSurveyWorkItemTypeOptions] = useState(
    []
  );
  const [surveyCallerTypeOptions, setSurveyCallerTypeOptions] = useState([]);
  const [infoTabSelected, setInfoTabSelected] = useState(0);
  const [surveyCaseIds, setSurveyCaseIds] = useState([]);
  const [surveyMostRecentCase, setSurveyMostRecentCase] = useState('');
  const [showVerintIdentifier, setShowVerintIdentifier] = useState(false);
  const [surveyResponses, setSurveyResponses] = useState([]);
  const contactsRef = useRef(contacts);
  const activeContactRef = useRef('');
  const [additionalDetails, setAdditionalDetails] = useState([]);
  const [notes, setNotes] = useState([]);
  const [addNotesList, setAddNotesList] = useState([]);
  const [inputList, setInputList] = useState([]);
  const [selected, setSelected] = useState([]);
  const [submitted, setSubmitted] = useState(false);
  let borderColorIndex = 0;

  let envConfig = config[window.location.hostname];

  const contactBorderColors = ['#62892E', '#0199A6', '#735F91'];

  const setContacts = contactsArr => {
    contactsRef.current = contactsArr;
    _setContacts(contactsArr);
  };

  const createNewContact = contact => {
    const tempContact = {
      contactId: contact.getContactId(),
      attributes: contact.getAttributes(),
      references: contact.getReferences()
    };

    return tempContact;
  };

  const getCallerType = callerType => {
    let mappedCallerType = '';
    switch (callerType) {
      case 'Family':
        mappedCallerType = 'Family Member/Partner';
        break;
      default:
        mappedCallerType = callerType;
        break;
    }

    return mappedCallerType;
  };

  const initSurveyResponses = contact => {
    return {
      contactId: contact.contactId,
      responses: {
        generalDetails: {
          firstName: user.firstName,
          lastName: user.lastName,
          email: user.email,
          customerNumber:
            contact.attributes.customerNumber &&
            contact.attributes.customerNumber.value !== ''
              ? contact.attributes.customerNumber.value
              : '',
          language:
            contact.attributes.Language &&
            contact.attributes.Language.value !== ''
              ? contact.attributes.Language.value === 'english'
                ? 'English'
                : 'Spanish'
              : 'English',
          callerType:
            contact.attributes.callerType &&
            contact.attributes.callerType.value !== ''
              ? getCallerType(contact.attributes.callerType.value)
              : '',
          requestType:
            contact.attributes.typeId && contact.attributes.typeId !== ''
              ? contact.attributes.typeId === 'Chat'
                ? contact.attributes.chatTopic.value ===
                  'File a new claim or leave'
                  ? 'Intake - Chat'
                  : 'Service - Chat'
                : contact.attributes.typeId === 'Task'
                ? contact.attributes.callReason &&
                  contact.attributes.callReason.value !== ''
                  ? 'Service - Outbound Scheduled Callback'
                  : contact.attributes.msgType &&
                    contact.attributes.msgType.value !== ''
                  ? 'Service - Employee Portal Failure Task'
                  : 'Service - Intermittent Absence Manual Handling Task'
                : contact.attributes.CallDisposition &&
                  contact.attributes.CallDisposition.value.endsWith('Intake')
                ? 'Intake - Call'
                : 'Service - Call'
              : 'Service - Call',
          claim:
            surveyCaseIds.length > 0
              ? surveyCaseIds.find(c => c.contactId === contact.contactId)
                  .mostRecent
              : '',
          workItemType: '',
          firstTimeIssue: 'Unknown',
          liabilityDecisionReceived: 'Yes'
        },
        callReasons: [],
        noteReasons: [],
        primaryCallReason: '',
        taskDetails: {
          successfullyReached: 'Yes',
          callBackAttempts: 0,
          callBackNumber:
            contact.attributes.numberToCall &&
            contact.attributes.numberToCall.value !== ''
              ? contact.attributes.numberToCall.value
              : '',
          callBackTopic:
            contact.attributes.callReason &&
            contact.attributes.callReason.value !== ''
              ? contact.attributes.callReason.value
              : ''
        },
        additionalDetails: '',
        notes: '',
        addNotesList: [],
        inputList: [],
        selected: '',
        note: ''
      }
    };
  };

  const formatDate = date => {
    let formattedDate = '';
    if (date.includes('T')) {
      const d = date.split('T')[0];
      formattedDate = d.replace(/(\d{4})-(\d{2})-(\d{2})/g, '$2-$3-$1');
      return formattedDate;
    } else if (!date.includes('T') && !date.includes('-')) {
      if (date.length === 8 && /^\d{8}$/.test(date)) {
        formattedDate = date.replace(/(\d{2})(\d{2})(\d{4})/g, '$1-$2-$3');
        return formattedDate;
      }
      formattedDate = date.replace(/(\d{1,2})(\d{1,2})(\d{4})/g, '$1-$2-$3');
      return formattedDate;
    } else {
      return date;
    }
  };

  const getInteractionType = contact => {
    if (contact.getType() === 'voice' || contact.getType() === 'queue_callback') {
      return contact
        .getConnections()[1]
        .getEndpoint().phoneNumber;
    } else if (contact.getType() === 'task') {
      return 'Task';
    } else {
      return 'Chat';
    }
  };

  const sendDesktopNotification = (contactName, contactId) => {
    const chatNotification = new Notification(`New Chat Message from ${contactName}`, {});
    chatNotification.onclick = () => {
      window.parent.parent.focus();
      //eslint-disable-next-line no-undef
      connect.core.viewContact(contactId);
    }
  }

  const handleChatMessageReceived = (event) => {
    const { data } = event;
    
    if(data.ParticipantRole === 'CUSTOMER') {
      if(document.visibilityState === 'hidden' || data.ContactId !== activeContactRef.current) {
        sendDesktopNotification(data.DisplayName, data.ContactId);
      } 
    }
  }

  // Increment index, reset to zero if at max value.
  function incrementBorderColorIndex(){
    if(borderColorIndex >= contactBorderColors.length -1){
      borderColorIndex = 0;
    }else{
      borderColorIndex++;
    }      
  }

  // Increment color index so that next contact 
  // accepted is assigned the next color.
  function setNextBorderColorIndex(){
    console.log("setNextBorderColorIndex");
    incrementBorderColorIndex();
    console.log("setNextBorderColorIndex", "borderColorIndex", borderColorIndex);

    // As there is only two chats max, and as setNextBorderColorIndex is called when a 
    // new call has been accepted, there is only one current active chat.
    // Check first contact in contacts array for borderColor currently in use.
    // Skip the color if it is already assigned to current chat.
    if(contactsRef.current.length > 0){
      const existingChatBorderColor = contactsRef.current[0].attributes.borderColor;
      const nextChatBorderColor = contactBorderColors[borderColorIndex];
      console.log("setNextBorderColorIndex", 
        "existingChatBorderColor", existingChatBorderColor, 
        "nextChatBorderColor", nextChatBorderColor);
      if(existingChatBorderColor === nextChatBorderColor){
        console.log("setNextBorderColorIndex", "color already in use, find next");
        incrementBorderColorIndex();
      }
    }
    console.log("setNextBorderColorIndex", "borderColorIndex", borderColorIndex, contactBorderColors[borderColorIndex]);
  }

  const handleContactConnecting = async contact => {
    console.log(contact);

    const newContact = createNewContact(contact);

    //event FullStory
    event('Contact Connecting', {
      contactId: newContact.contactId
    });

    //Set interaction type
    newContact.attributes.typeId = getInteractionType(contact);

    const kenticoContentResponse = await remoteConfigManager.getSurveyContent();
    console.log('Kentico Response: ' + JSON.stringify(kenticoContentResponse));
    setSurveyCalls(
      kenticoContentResponse.calls
    );
    setSurveyChats(
      kenticoContentResponse.chats
    );
    setSurveyCallbackTask(
      kenticoContentResponse.callback_task_outbound_call
    );
    setSurveyFailureTask(
      kenticoContentResponse.employee_portal_failure_task
    );
    setSurvveyIntermittentAbsenceTask(
      kenticoContentResponse.intermittent_absence_task
    );
    setSurveyRequestTypeOptions(
      kenticoContentResponse.request_type_options.options.value.split('|')
    );
    setSurveyWorkItemTypeOptions(
      kenticoContentResponse.work_item_type_options.options.value.split('|')
    );
    setSurveyCallerTypeOptions(
      kenticoContentResponse.caller_type.options.value.split('|')
    );

    if (newContact?.attributes) {
      
      if (
        newContact.attributes.customerId &&
        newContact.attributes.customerId.value !== ''
      ) {
        const returnedCaseIds = await remoteConfigManager.getCaseIds(
          newContact.attributes.customerId
        );
        if (returnedCaseIds && 
          returnedCaseIds !== undefined && 
          Object.prototype.hasOwnProperty.call(returnedCaseIds, 'casedIds')) {
          setSurveyCaseIds(prevCaseIds => [
            ...prevCaseIds,
            {
              contactId: newContact.contactId,
              caseIds: ['N/A', 'Other', ...returnedCaseIds.casedIds],
              mostRecent:
                returnedCaseIds.mostRecent && returnedCaseIds.mostRecent !== ''
                  ? returnedCaseIds.mostRecent
                  : ''
            }
          ]);
        }
      } else if (
        newContact.attributes.eid &&
        newContact.attributes.eid.value !== ''
      ) {
        const returnedCaseIds = await remoteConfigManager.getCaseIds(
          newContact.attributes.eid
        );
        if (returnedCaseIds && 
            returnedCaseIds !== undefined && 
            Object.hasOwn(returnedCaseIds, 'casedIds')) {
          setSurveyCaseIds(prevCaseIds => [
            ...prevCaseIds,
            {
              contactId: newContact.contactId,
              caseIds: ['N/A', 'Other', ...returnedCaseIds.casedIds],
              mostRecent:
                returnedCaseIds.mostRecent && returnedCaseIds.mostRecent !== ''
                  ? returnedCaseIds.mostRecent
                  : ''
            }
          ]);
        }
      } else {
        setSurveyCaseIds(['N/A', 'Other']);
      }
    }
  };

  const handleContactAccepted = async contact => {
    console.log('CONTACT ACCEPTED');
    const newContact = createNewContact(contact);

    newContact.attributes.contactId = newContact.contactId;

    //eslint-disable-next-line no-undef
    if (contact.getType() === connect.ContactType.CHAT) {
      newContact.attributes.borderColor = contactBorderColors[borderColorIndex];
      setNextBorderColorIndex();
    }

    //event FullStory
    event('Contact Accepted', {
      contactId: newContact.contactId
    });

    const contactType = contact.getType();
    const dobValue = newContact.attributes.dob?.value;
    
    if (dobValue && dobValue !== '') {
      //eslint-disable-next-line no-undef
      if(contactType === connect.ContactType.VOICE) { //DOB is only encrypted for voice contacts
        newContact.attributes.plainTextDob = { value: '' }
        webApisClient.decryptAttribute(dobValue).then(decryptedDob => {
          setAttributesMap(prev => ({
              ...prev,
              plainTextDob: { value: formatDate(decryptedDob) }
            }));
        });
      } else {
        newContact.attributes.plainTextDob = { value: formatDate(dobValue) }; 
      }
    }
    
    if (contactType === 'voice' || contactType === 'queue_callback') {
      newContact.attributes.typeId = contact
        .getConnections()[1]
        .getEndpoint().phoneNumber;
    } else {
      newContact.attributes.typeId = 'Chat';
    }
    
    if (contact.getType() === 'task') {
      newContact.attributes.typeId = 'Task';            
    }

    if (
      newContact.attributes.customerNumber &&
      newContact.attributes.customerNumber.value !== ''
      ) {
        try {
          remoteConfigManager.hasTasks(newContact.attributes.customerNumber).then(res => {
            if(res.hasTasks === 'Yes') {
              newContact.attributes.hasTasks = {'value': true};
            }
            });
        } catch(error) {
          console.log(error);
        }
      }

    const initialResponses = initSurveyResponses(newContact);
    setSurveyResponses(prevResponses => [...prevResponses, initialResponses]);

    //Set Verint div to visible
    setShowVerintIdentifier(true);

    // There is an existing issue where the handleContactAccepted event
    // is triggered twice per new contact. To make sure we are not 
    // setting duplicate entries in the contacts array, filter out duplicates.  
    const deDupedContacts = [...contactsRef.current, newContact].reduce((acc, obj) => {
      if (!acc.some(o => o.attributes.contactId === obj.attributes.contactId)) {
        acc.push(obj);
      }
      return acc;}, []
    );

    setContacts(deDupedContacts);
    setInfoTabSelected(0);
    setAttributesMap(newContact.attributes);
    activeContactRef.current = newContact.contactId;

    //eslint-disable-next-line no-undef
    if (contact.getType() === connect.ContactType.CHAT) {
      //eslint-disable-next-line no-undef
      const cnn = contact.getConnections().find(cnn => cnn.getType() === connect.ConnectionType.AGENT);

      //eslint-disable-next-line no-undef
      const agentChatSession = await cnn.getMediaController();

      agentChatSession.onMessage(handleChatMessageReceived);
    }

    setCCPWidth(60);
    setShowSpinner(true);
    setTimeout(() => {
      setShowSpinner(false);
      setShowInfoPanel(true);
    }, 1000);
    clearTimeout();
  };

  /** @param {connect.Contact} contact */
  const handleSendDefaultGreeting = async contact => {

    console.log(`SEND DEFAULT GREETIMG-${contact.contactId}`);
    
    //event FullStory
    event('Send Default Greeting', {
      contactId: contact.contactId
    });
    
    
    // eslint-disable-next-line no-undef
    const ccpApi = connect;

    if (contact.getType() === ccpApi.ContactType.CHAT) {
      const agentInfo =  new ccpApi.Agent().getConfiguration();
      const cnn = contact.getConnections().find(cnn => cnn.getType() === ccpApi.ConnectionType.AGENT);
      const agentChatSession = await cnn.getMediaController();

      try {
        // The API call below will send an initial greeting to the customer. While the
        // onConnected event could execute multiple times per chat session (i.e. due to
        // browser refreshes, new tab loads, multiple browser tabs/instances/etc), the 
        // API below will not send the same message more than once for the same ClientToken.
        await fetch('https://participant.connect.us-east-1.amazonaws.com/participant/message', {
          headers: {
            'content-type': 'application/json',
            'x-amz-bearer': agentChatSession.controller.connectionHelper.getConnectionToken(),
          },
          method: 'POST',
          body: JSON.stringify({
            ClientToken: `${contact.contactId}-INITIAL_GREETING`,
            Content: `Hello! My name is ${agentInfo.firstName}, and I would be more than happy to assist you today. May I call you by your first name?`,
            ContentType: 'text/plain',
          }),
        });
      } catch(error) {
        console.log(error);
      }
    }
  };

  /** @param {connect.Contact} contact */
  const handleContactConnected = async contact => {

    console.log('CONTACT CONNECTED');

    //event FullStory
    event('Contact Connected', {
      contactId: contact.contactId
    });

    //we will delay sending the default greeting for 3 seconds.
    //this will allow the chat topic/details customer messages captured by the EE portal
    //to process so that the default greeting timestamp can reliably "follow"
    //those special messages in the chat message order/transcription
    console.log(`INITIATING TIMER FOR SENDING DEFAULT GREETING-${contact.contactId}`);
    setTimeout(handleSendDefaultGreeting, 3000, contact);
    console.log(`DELAY FOR SENDING DEFAULT GREETING INITIATED-${contact.contactId}`);
  };

  const handleAfterCallWork = contact => {
    //event FullStory
    event('Contact ACW', {
      contactId: contact.contactId
    });
    setInfoTabSelected(1);
  };

  const handleContactDestroyed = contact => {

    //event FullStory
    event('Contact Destroyed', {
      contactId: contact.contactId
    });

    if (contact && contact.contactId !== '') {
      const filteredContacts = contactsRef.current.filter(
        con => con.contactId !== contact.contactId
      );
      setContacts(filteredContacts);
      if (contactsRef.current.length === 0) {
        activeContactRef.current = '';
        setShowInfoPanel(false);
        setContacts([]);
        setAttributesMap({});
        setCCPWidth(95);
        setShowVerintIdentifier(false);
      }
    }
  };

  const handleContactViewed = viewEvent => {
    // event FullStory
    event('Contact Viewed', {
      contactId: viewEvent.contactId
    });

    console.log(viewEvent);
    if (viewEvent.contactId !== '' && contactsRef.current.length > 0) {
      setShowInfoPanel(false);
      const contact = contactsRef.current.find(
        con => con.contactId === viewEvent.contactId
      );

      activeContactRef.current = contact.contactId;
      setAttributesMap(contact.attributes);

      setCCPWidth(60);
      setShowSpinner(true);
      setTimeout(() => {
        setShowSpinner(false);
        setShowInfoPanel(true);
        setInfoTabSelected(0);
      }, 1000);
      clearTimeout();
    }
  };

  useEffect(() => {
    console.log('INSIDE USE EFFECT');
    const user = remoteConfigManager.getUser();
    setUser(user);
    // Identify method FullStory
    identify(user.employeeId, {
      displayName: user.firstName + ' ' + user.lastName
    });
    if(("Notification" in window)) {
      Notification.requestPermission();
    }
    if (!ccpInitialized) {
      setccpInitialized(true);
      const url = 'https://myapps.microsoft.com/signin/' + envConfig.azureTenant;
      const ccpUrl = envConfig.ccpUrl;

      window['_fs_run_in_iframe'] = true;
      const ccpContainer = document.getElementById('ccp');
      // Initialize the CCP window
      // eslint-disable-next-line no-undef
      connect.core.initCCP(ccpContainer, {
        ccpUrl: ccpUrl,
        loginPopup: true,
        loginUrl: url,
        loginPopupAutoClose: true,
        softphone: {
          allowFramedSoftphone: true
        },
        region: 'us-east-1' // REQUIRED for `CHAT`, optional otherwise
      });

      // eslint-disable-next-line no-undef
      connect.core.onAuthorizeSuccess(() => {
        console.log('authorization succeeded!');
        setLoggedIn(true);
      });

      // eslint-disable-next-line no-undef
      const eventBus = connect.core.getEventBus();
      // eslint-disable-next-line no-undef
      eventBus.subscribe(connect.EventType.TERMINATED, () => {
        console.log('Logged out');
        setLoggedIn(false);
        setccpInitialized(false);
      });

      //Subscribe to contact events so we can handle them
      // eslint-disable-next-line no-undef
      connect.contact(function(contact) {

        contact.onConnecting(handleContactConnecting);
        contact.onAccepted(handleContactAccepted);
        contact.onConnected(handleContactConnected);
        contact.onACW(handleAfterCallWork);
        contact.onDestroy(handleContactDestroyed);
      });

      // eslint-disable-next-line no-undef
      connect.core.onViewContact(handleContactViewed);
    }
  }, []);

  // Called from infoTab to set the CCP component to 
  // show the same contact.
  const handleInfoTabContactViewed = contactId => {
    handleContactViewed({ "contactId": contactId })
    //eslint-disable-next-line no-undef
    connect.core.viewContact(contactId);
  }

  return (
    <div
      id="parent"
      style={{
        height: '98vh',
        width: '100vw',
        margin: '0',
        backgroundColor: '#F6F8FA',
        overflow: 'hidden'
      }}
    >
      {loggedIn ? (
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <CCPContainer width={ccpWidth} contactAttributes={attributesMap} />
          {contacts.length > 0 ? (
            <div>
              {showSpinner ? (
                <div id="InfoTabSpinner" className="spinnerContainer">
                  <FontAwesomeIcon
                    icon={faSpinner}
                    size="3x"
                    className="fa-spinner"
                    spin
                  />
                </div>
              ) : (
                ''
              )}
              {showInfoPanel ? (
                <InfoTab
                  handleInfoTabContactViewedFunction={handleInfoTabContactViewed}
                  contacts={contacts}
                  borderColor={contactBorderColors[borderColorIndex]}
                  infoTabSelected={infoTabSelected}
                  setInfoTabSelected={setInfoTabSelected}
                  user={user}
                  contactAttributes={attributesMap}
                  surveyResponses={surveyResponses}
                  setSurveyResponses={setSurveyResponses}
                  calls={surveyCalls}
                  chats={surveyChats}
                  failureTask={surveyFailureTask}
                  callbackTask={surveyCallbackTask}
                  intermittentAbsenceTask={surveyIntermittentAbsenceTask}
                  requestTypeOptions={surveyRequestTypeOptions}
                  workItemTypeOptions={surveyWorkItemTypeOptions}
                  callerTypeOptions={surveyCallerTypeOptions}
                  caseIds={surveyCaseIds}
                  surveyMostRecentCase={surveyMostRecentCase}
                  showVerintIdentifier={showVerintIdentifier}
                  additionalDetails={setAdditionalDetails}
                  notes={setNotes}
                  addNotesList={setAddNotesList}
                  inputList={setInputList}
                  selected={setSelected}
                  submitted={setSubmitted}
                />
              ) : (
                ''
              )}
            </div>
          ) : (
            ''
          )}
        </div>
      ) : (
        <NotLoggedIn />
      )}
    </div>
  );
};

export default ParentContainer;
